import GiftCardEdit from "./GiftCardEdit";
import GiftCardCreate from "./GiftCardCreate";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { VOUCHER_TYPE_OPTIONS } from "@/constants/voucherType";

export const giftcards = {
  edit: GiftCardEdit,
  create: GiftCardCreate,
  icon: CardGiftcardIcon,
  options: {
    label:
      VOUCHER_TYPE_OPTIONS.find((t) => t.value === "gift_card")?.label ||
      "Gift Cards",
  },
};
